<template>
  <DragPanel
    title="视口"
    :closePanel="closePanel"
    :tooltipVisible="false">
    <div class="action-btn-box">
      <el-button
        v-if="isChecked('Project.Single.SceneViewPort.Operate')"
        type="primary"
        class="primary-btn primary-ang-btn"
        size="small"
        icon="el-icon-plus"
        @click="openAddViewportDialog()">
        新建视口
      </el-button>
      <el-button
        v-if="isChecked('Project.Single.SceneViewPort.Operate')"
        class="normal-btn primary-ang-btn"
        size="small"
        @click="resetViewport">
        恢复至默认视口
      </el-button>
    </div>
    <ViewportList
      :viewportList="viewportList"
      :refreshViewportList="refreshViewportList"
      @openViewportDialog="openViewportDialog"
      @openViewportDetailsPanel="openViewportDetailsPanel" />
    <ViewportDetailsPanel
      v-if="isViewportDetailsPanelVisible"
      :viewportDetails="viewportDetails"
      :closeViewportDetailsPanel="closeViewportDetailsPanel" />
  </DragPanel>
</template>

<script>
import DragPanel from '@/components/CustomDragPanel.vue'
import ViewportList from './ViewportList.vue'
import ViewportDetailsPanel from './ViewportDetailsPanel.vue'

import { Store } from '@/utils/store'

import {
  getSceneViewportListService,
  setViewAngleService,
  resetSceneViewportDefultService
} from '@/service/interface.js'

export default {
  data() {
    return {
      viewportList: [],

      isViewportDetailsPanelVisible: false,
      viewportDetails: {}
    }
  },
  props: {
    openAddViewportDialog: Function,
    closeViewportPanel: Function
  },
  components: {
    DragPanel,
    ViewportList,
    ViewportDetailsPanel
  },
  mounted() {
    this.initViewportList()
  },
  methods: {
    initViewportList() {
      this.queryViewportList().then(viewportList => {
        this.viewportList = viewportList
      })
    },
    openViewportDialog(viewportInfo) {
      this.openAddViewportDialog(viewportInfo)
    },
    resetViewport() {
      let projId = this.$route.params.projId
      let resourceId = this.$route.query.sceneId
      let params = {
        projId,
        resourceId,
        definedType: 2,
        visualAngle: 'DefaultVisualAngle'
      }
      setViewAngleService(params).then(response => {
        if (response.isSuccess) {
          let sceneId = this.$route.query.sceneId
          resetSceneViewportDefultService(sceneId).then(res => {
            if (res.isSuccess) {
              this.resetCameraLoc()
              this.refreshViewportList()
            } else {
              this.$message.error(res.errMsg)
            }
          })
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    resetCameraLoc() {
      const BlackHole3D = window.BlackHole3D

      let forceCamLoc = new BlackHole3D.REForceCamLoc()
      forceCamLoc.force = false
      forceCamLoc.camPos = [0, 0, 0]
      forceCamLoc.camRotate = [0, 0, 0, 0]
      BlackHole3D.Camera.setCamForcedInitLoc(forceCamLoc)

      BlackHole3D.Camera.resetCamLocate()
    },
    openViewportDetailsPanel(viewportInfo) {
      this.viewportDetails = viewportInfo
      this.isViewportDetailsPanelVisible = true
    },
    closeViewportDetailsPanel() {
      this.viewportDetails = {}
      this.isViewportDetailsPanelVisible = false
    },
    refreshViewportList() {
      return new Promise(resolve => {
        this.queryViewportList().then(viewportList => {
          this.viewportList = viewportList
          resolve()
        })
      })
    },
    queryViewportList() {
      return new Promise(resolve => {
        let sceneId = this.$route.query.sceneId
        getSceneViewportListService(sceneId).then(response => {
          if (response.isSuccess) {
            let viewportList = response.data
            resolve(viewportList)
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    closePanel() {
      this.closeViewportPanel()
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData
      let find = permissionData.find(el => el.permissionCode === permissionCode)
      return find.isCheck
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.common-drag-panel {
  top: 214px;
  right: 20px;
  width: 360px;
  height: calc(100% - 225px);
  min-width: 300px;

  :deep(.content) {
    display: flex;
    flex-direction: column;
    height: calc(100% - 40px);
    padding: 8px 16px 16px 16px;

    .action-btn-box {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 7px;

      .el-button {
        span {
          display: inline;
        }

        & + .el-button {
          margin-left: 0px;
        }
      }
    }
  }
}
</style>
